document.addEventListener("DOMContentLoaded", function () {
  // Initialize filter functionality
  initAjaxFilters();

  function initAjaxFilters() {
    // Elements - using querySelectorAll for safety
    const filterLinks = document.querySelectorAll(".js-tag-filter");
    const productGrid = document.querySelector(".collection-matrix");
    const loadingIcon = document.querySelector(".collection__loading-icon");
    const resetButtons = document.querySelectorAll(".reset-filters-button");

    // Safety check: Exit if we're not on a collection page with the required elements
    if (!productGrid) {
      console.log(
        "Product grid not found, exiting collection filter initialization"
      );
      return;
    }

    // Store current active filters
    let activeFilters = new Set();
    let currentSort = "";

    // Initialize active filters from URL on page load
    if (window.location.pathname.includes("/collections/")) {
      const pathParts = window.location.pathname.split("/");
      if (pathParts.length > 3) {
        // Format is /collections/collection-name/tags
        const tagPath = pathParts[3]; // This is the tags part
        if (tagPath && !tagPath.includes(".")) {
          const tags = tagPath.split("+");
          tags.forEach((tag) => activeFilters.add(tag));
        }
      }
    }

    // Get sort value from URL
    const urlParams = new URLSearchParams(window.location.search);
    currentSort = urlParams.get("sort_by") || "";

    // Update filter link states based on activeFilters
    function updateFilterUI() {
      filterLinks.forEach((link) => {
        const tagHandle = link.getAttribute("data-tag");
        if (activeFilters.has(tagHandle)) {
          link.classList.add("is-active");
        } else {
          link.classList.remove("is-active");
        }
      });

      // Update reset filter buttons visibility - with safety checks
      resetButtons.forEach((resetButton) => {
        const countElement = resetButton.querySelector(".filter-count");
        if (countElement) {
          countElement.textContent = activeFilters.size || "0";
        }
        resetButton.setAttribute(
          "data-filter-count",
          activeFilters.size || "0"
        );
      });
    }

    // Handle filter link clicks
    filterLinks.forEach((link) => {
      link.addEventListener("click", function (e) {
        e.preventDefault();

        const tagHandle = this.getAttribute("data-tag");
        if (!tagHandle) return; // Safety check

        const tagGroup = this.getAttribute("data-group");

        // Toggle filter selection
        if (activeFilters.has(tagHandle)) {
          activeFilters.delete(tagHandle);
        } else {
          // For tag groups, we might want to ensure only one tag per group is selected
          if (tagGroup) {
            // Remove other tags from the same group
            filterLinks.forEach((otherLink) => {
              if (otherLink.getAttribute("data-group") === tagGroup) {
                const otherTagHandle = otherLink.getAttribute("data-tag");
                if (otherTagHandle) {
                  activeFilters.delete(otherTagHandle);
                }
              }
            });
          }
          activeFilters.add(tagHandle);
        }

        // Update UI
        updateFilterUI();

        // Load filtered products
        loadFilteredProducts();

        // If mobile filter sidebar is open, close it
        if (
          typeof window.toggleFilters === "function" &&
          document
            .getElementById("mobile-filter-sidebar")
            ?.classList.contains("is-open")
        ) {
          window.toggleFilters();
        }
      });
    });

    // Helper function to set up reset button event listeners
    function setupResetButtons() {
      resetButtons.forEach((resetButton) => {
        resetButton.addEventListener("click", function (e) {
          e.preventDefault();

          // Clear all active filters
          activeFilters.clear();

          // Update UI
          updateFilterUI();

          // Load all products (no filters)
          loadFilteredProducts();
        });
      });
    }

    // Initialize reset buttons
    setupResetButtons();

    // Handle sort changes for the dropdown form
    const sortByFilter = document.getElementById("sort-by-filter");
    if (sortByFilter) {
      sortByFilter.addEventListener("change", function (e) {
        // Prevent default form submission
        if (e.target.form) {
          e.preventDefault();
        }

        // Get new sort value
        currentSort = this.value;

        // Load products with new sort
        loadFilteredProducts();
      });
    }

    // Handle sort changes for custom dropdown links
    const sortDropdownLinks = document.querySelectorAll(".dropdown-list a");
    if (sortDropdownLinks.length > 0) {
      sortDropdownLinks.forEach((link) => {
        link.addEventListener("click", function (e) {
          e.preventDefault();
          console.log("Sort link clicked");

          try {
            // Extract sort value from the URL
            const url = new URL(this.href);
            const sortValue = url.searchParams.get("sort_by") || "";

            // Update current sort
            currentSort = sortValue;

            // Update dropdown button text to show the selected option
            const dropdownButton =
              this.closest(".custom-dropdown")?.querySelector(
                ".dropdown-button"
              );
            if (dropdownButton) {
              // Get the text content of the clicked link
              const linkText = this.textContent.trim();
              // Find the text node (first child) and update it
              if (
                dropdownButton.childNodes.length > 0 &&
                dropdownButton.childNodes[0].nodeType === Node.TEXT_NODE
              ) {
                dropdownButton.childNodes[0].nodeValue = linkText;
              } else {
                // Fallback if the structure is different
                dropdownButton.textContent = linkText;
                // Preserve the arrow if it exists
                const arrow =
                  this.closest(".custom-dropdown")?.querySelector(
                    ".dropdown-arrow"
                  );
                if (arrow) {
                  dropdownButton.appendChild(arrow.cloneNode(true));
                }
              }
            }

            // Close the dropdown
            const dropdownList = this.closest(".dropdown-list");
            if (dropdownList) {
              dropdownList.classList.remove("is-open");
              const arrow =
                dropdownList.previousElementSibling?.querySelector(
                  ".dropdown-arrow"
                );
              if (arrow) {
                arrow.style.transform = "rotate(0deg)";
              }
            }

            // Load filtered products with new sort
            loadFilteredProducts();
          } catch (error) {
            console.error("Error handling sort click:", error);
            // If there's an error, allow the default link behavior
            window.location.href = this.href;
          }
        });
      });
    }

    // Function to load filtered products via AJAX
    function loadFilteredProducts() {
      console.log("Loading filtered products");

      // Show loading indicator
      if (loadingIcon) {
        loadingIcon.style.display = "block";
      }

      if (productGrid) {
        productGrid.classList.add("loading");
        productGrid.style.opacity = "0.5";
      }

      // Build URL for filtered products
      // Get the collection handle from the current URL path
      const pathParts = window.location.pathname.split("/");
      // Format should be /collections/collection-name
      const collectionHandle = pathParts[2] || "";

      // Base URL is always the collection URL
      let url = `/collections/${collectionHandle}`;

      // Add tag filters if any - but DON'T include the collection handle as a tag
      if (activeFilters.size > 0) {
        // Filter out the collection handle itself from active filters
        const tagsOnly = Array.from(activeFilters).filter(
          (tag) => tag !== collectionHandle
        );

        if (tagsOnly.length > 0) {
          const tagsPath = tagsOnly.join("+");
          // The correct format is /collections/collection-name/tag1+tag2
          url = `${url}/${tagsPath}`;
        }
      }

      // Add sort parameter if any
      const params = new URLSearchParams();
      if (currentSort) {
        params.set("sort_by", currentSort);
      }

      const queryString = params.toString();
      if (queryString) {
        url = `${url}?${queryString}`;
      }

      console.log("Fetching URL:", url);

      // Update URL without refreshing
      try {
        window.history.pushState({ path: url }, "", url);
      } catch (e) {
        console.error("Error updating URL:", e);
      }

      // Fetch filtered products
      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Error ${response.status}: ${response.statusText}`);
          }
          return response.text();
        })
        .then((html) => {
          try {
            // Create a new DOM parser and parse the HTML
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");

            // Check if there are no products found
            const noProductsMessage = doc.querySelector(
              ".container--no-products-in-collection"
            );

            if (noProductsMessage) {
              // Check if we already have a no-products container in our current page
              let currentNoProductsContainer = document.querySelector(
                ".container--no-products-in-collection"
              );

              // If we don't have one, we need to create it
              if (!currentNoProductsContainer) {
                currentNoProductsContainer = document.createElement("div");
                currentNoProductsContainer.className =
                  "container container--no-products-in-collection text-align-center has-padding-bottom has-padding-top";

                // Create inner content
                const innerColumn = document.createElement("div");
                innerColumn.className = "one-whole column";

                const noProductsText = document.createElement("p");
                noProductsText.textContent =
                  "No products match the selected filters.";

                // Assemble the elements
                innerColumn.appendChild(noProductsText);
                currentNoProductsContainer.appendChild(innerColumn);

                // Insert the no products message before or after the product grid
                if (productGrid && productGrid.parentNode) {
                  productGrid.parentNode.insertBefore(
                    currentNoProductsContainer,
                    productGrid
                  );
                  productGrid.style.display = "none";
                }
              } else {
                // If we already have a no-products container, just make sure it's visible
                currentNoProductsContainer.style.display = "block";
                if (productGrid) {
                  productGrid.style.display = "none";
                }
              }

              // Hide pagination when no products
              const paginationContainer = document.querySelector(
                ".container--pagination"
              );
              if (paginationContainer) {
                paginationContainer.style.display = "none";
              }
            } else {
              // Hide any existing no-products message
              const currentNoProductsContainer = document.querySelector(
                ".container--no-products-in-collection"
              );
              if (currentNoProductsContainer) {
                currentNoProductsContainer.style.display = "none";
              }

              // Show the product grid
              if (productGrid) {
                productGrid.style.display = "grid";
              }

              // Extract the new product grid
              const newProductGrid = doc.querySelector(".collection-matrix");

              // Update product grid if found
              if (newProductGrid && productGrid) {
                productGrid.innerHTML = newProductGrid.innerHTML;
              } else {
                // Try a different selector - inspect your HTML to find what the actual container is
                const alternativeGrid = doc.querySelector(
                  ".container.collection-matrix"
                );
                if (alternativeGrid && productGrid) {
                  productGrid.innerHTML = alternativeGrid.innerHTML;
                }
              }

              // Update pagination container
              const paginationContainer = document.querySelector(
                ".container--pagination"
              );
              const newPaginationContainer = doc.querySelector(
                ".container--pagination"
              );

              if (paginationContainer && newPaginationContainer) {
                // Update pagination content
                paginationContainer.innerHTML =
                  newPaginationContainer.innerHTML;
                // Make sure it's visible
                paginationContainer.style.display = "block";
              } else if (paginationContainer && !newPaginationContainer) {
                // If there's no pagination in the response but we have a container, hide it
                paginationContainer.style.display = "none";
              } else if (!paginationContainer && newPaginationContainer) {
                // If we don't have a pagination container but there is one in the response, add it
                const productGridWrapper = document.querySelector(
                  ".collection-matrix__wrapper"
                );
                if (productGridWrapper) {
                  const newPaginationClone =
                    newPaginationContainer.cloneNode(true);
                  productGridWrapper.appendChild(newPaginationClone);
                }
              }
            }

            // Update product count if displayed
            const collectionTitle = document.querySelector(".collection-title");
            const newCollectionTitle = doc.querySelector(".collection-title");
            if (collectionTitle && newCollectionTitle) {
              collectionTitle.innerHTML = newCollectionTitle.innerHTML;
            }

            // Update filter counts
            document
              .querySelectorAll(".filter-count")
              .forEach((countElement) => {
                // Always show "0" if there are no filters
                countElement.textContent = activeFilters.size || "0";
              });

            // Update pagination links to work with our AJAX approach
            updatePaginationLinks();

            // Hide loading indicator
            if (loadingIcon) {
              loadingIcon.style.display = "none";
            }

            if (productGrid) {
              productGrid.classList.remove("loading");
              productGrid.style.opacity = "1";
            }

            // Re-initialize any product-specific JavaScript that might be needed
            if (typeof window.reinitializeProductJS === "function") {
              window.reinitializeProductJS();
            }
          } catch (error) {
            console.error("Error processing AJAX response:", error);
            // On error, fall back to regular page navigation
            window.location.href = url;
          }
        })
        .catch((error) => {
          console.error("Error fetching filtered products:", error);
          // On fetch error, fall back to regular page navigation
          window.location.href = url;
        });
    }

    // Function to update pagination links to use AJAX instead of page reloads
    function updatePaginationLinks() {
      const paginationLinks = document.querySelectorAll(".pagination a");

      paginationLinks.forEach((link) => {
        // Skip if it's not a regular link
        if (!link.href || link.href.includes("javascript:")) {
          return;
        }

        // Add click event to handle pagination via AJAX
        link.addEventListener("click", function (e) {
          e.preventDefault();

          try {
            // Get the URL from the link
            const url = new URL(this.href);

            // Show loading indicator
            if (loadingIcon) {
              loadingIcon.style.display = "block";
            }

            if (productGrid) {
              productGrid.classList.add("loading");
              productGrid.style.opacity = "0.5";
            }

            // Update URL without refreshing
            window.history.pushState({}, "", url.toString());

            // Fetch the new page
            fetch(url.toString())
              .then((response) => {
                if (!response.ok) {
                  throw new Error(
                    `Error ${response.status}: ${response.statusText}`
                  );
                }
                return response.text();
              })
              .then((html) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");

                // Check for no products message
                const noProductsMessage = doc.querySelector(
                  ".container--no-products-in-collection"
                );

                if (noProductsMessage) {
                  // Handle no products message
                  let currentNoProductsContainer = document.querySelector(
                    ".container--no-products-in-collection"
                  );

                  if (!currentNoProductsContainer) {
                    currentNoProductsContainer = document.createElement("div");
                    currentNoProductsContainer.className =
                      "container container--no-products-in-collection text-align-center has-padding-bottom has-padding-top";

                    const innerColumn = document.createElement("div");
                    innerColumn.className = "one-whole column";

                    const noProductsText = document.createElement("p");
                    noProductsText.textContent =
                      "No products match the selected filters.";

                    innerColumn.appendChild(noProductsText);
                    currentNoProductsContainer.appendChild(innerColumn);

                    if (productGrid && productGrid.parentNode) {
                      productGrid.parentNode.insertBefore(
                        currentNoProductsContainer,
                        productGrid
                      );
                      productGrid.style.display = "none";
                    }
                  } else {
                    currentNoProductsContainer.style.display = "block";
                    if (productGrid) {
                      productGrid.style.display = "none";
                    }
                  }

                  // Hide pagination when no products
                  const paginationContainer = document.querySelector(
                    ".container--pagination"
                  );
                  if (paginationContainer) {
                    paginationContainer.style.display = "none";
                  }
                } else {
                  // Hide any existing no-products message
                  const currentNoProductsContainer = document.querySelector(
                    ".container--no-products-in-collection"
                  );
                  if (currentNoProductsContainer) {
                    currentNoProductsContainer.style.display = "none";
                  }

                  // Show the product grid
                  if (productGrid) {
                    productGrid.style.display = "grid";
                  }

                  // Extract the new product grid
                  const newProductGrid =
                    doc.querySelector(".collection-matrix");

                  // Update product grid if found
                  if (newProductGrid && productGrid) {
                    productGrid.innerHTML = newProductGrid.innerHTML;
                  }

                  // Update pagination
                  const pagination = document.querySelector(
                    ".container--pagination"
                  );
                  const newPagination = doc.querySelector(
                    ".container--pagination"
                  );
                  if (pagination && newPagination) {
                    pagination.innerHTML = newPagination.innerHTML;
                    pagination.style.display = "block";
                  }
                }

                // Re-update the pagination links again for the new pagination
                updatePaginationLinks();

                // Update filter counts after pagination
                document
                  .querySelectorAll(".filter-count")
                  .forEach((countElement) => {
                    countElement.textContent = activeFilters.size || "0";
                  });

                // Hide loading indicator
                if (loadingIcon) {
                  loadingIcon.style.display = "none";
                }

                if (productGrid) {
                  productGrid.classList.remove("loading");
                  productGrid.style.opacity = "1";
                }

                // Scroll to top of products if needed
                window.scrollTo({
                  top: productGrid.offsetTop - 100,
                  behavior: "smooth",
                });

                // Re-initialize any product-specific JavaScript
                if (typeof window.reinitializeProductJS === "function") {
                  window.reinitializeProductJS();
                }
              })
              .catch((error) => {
                console.error("Error fetching paginated content:", error);
                // On error, fall back to regular navigation
                window.location.href = url.toString();
              });
          } catch (error) {
            console.error("Error handling pagination click:", error);
            // If there's an error, allow the default link behavior
            window.location.href = this.href;
          }
        });
      });
    }

    // Handle browser back/forward navigation
    window.addEventListener("popstate", function (event) {
      // Reset active filters
      activeFilters.clear();

      // Extract tag filters from URL
      if (window.location.pathname.includes("/collections/")) {
        const pathParts = window.location.pathname.split("/");
        if (pathParts.length > 3) {
          const tagPath = pathParts[3];
          if (tagPath && !tagPath.includes(".")) {
            const tags = tagPath.split("+");
            tags.forEach((tag) => activeFilters.add(tag));
          }
        }
      }

      // Extract sort from URL
      const urlParams = new URLSearchParams(window.location.search);
      currentSort = urlParams.get("sort_by") || "";

      if (sortByFilter) {
        sortByFilter.value = currentSort || "manual";
      }

      // Update dropdown button text if using custom dropdowns
      const sortDropdowns = document.querySelectorAll(".custom-dropdown");
      if (sortDropdowns.length > 0) {
        sortDropdowns.forEach((dropdown) => {
          const dropdownButton = dropdown.querySelector(".dropdown-button");
          const dropdownLinks = dropdown.querySelectorAll(".dropdown-list a");

          // Find the matching link for the current sort
          let matchingText = "";
          dropdownLinks.forEach((link) => {
            if (!link.href) return;

            try {
              const linkUrl = new URL(link.href);
              const linkSort = linkUrl.searchParams.get("sort_by") || "manual";
              if (
                linkSort === currentSort ||
                (!currentSort && linkSort === "manual")
              ) {
                matchingText = link.textContent.trim();
              }
            } catch (e) {
              console.error("Error parsing link URL:", e);
            }
          });

          // Update button text if we found a match
          if (matchingText && dropdownButton) {
            // Safely update text
            try {
              if (
                dropdownButton.childNodes.length > 0 &&
                dropdownButton.childNodes[0].nodeType === Node.TEXT_NODE
              ) {
                dropdownButton.childNodes[0].nodeValue = matchingText;
              } else {
                // Fallback if the structure is different
                const arrow = dropdownButton.querySelector(".dropdown-arrow");
                dropdownButton.textContent = matchingText;
                if (arrow) {
                  dropdownButton.appendChild(arrow);
                }
              }
            } catch (e) {
              console.error("Error updating dropdown text:", e);
            }
          }
        });
      }

      // Update filter UI
      updateFilterUI();

      // Reload products based on URL
      const url = window.location.pathname + window.location.search;

      // Show loading indicator
      if (loadingIcon) {
        loadingIcon.style.display = "block";
      }

      if (productGrid) {
        productGrid.classList.add("loading");
        productGrid.style.opacity = "0.5";
      }

      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Error ${response.status}: ${response.statusText}`);
          }
          return response.text();
        })
        .then((html) => {
          try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");

            // Check for no products message
            const noProductsMessage = doc.querySelector(
              ".container--no-products-in-collection"
            );

            if (noProductsMessage) {
              // Handle no products message
              let currentNoProductsContainer = document.querySelector(
                ".container--no-products-in-collection"
              );

              if (!currentNoProductsContainer) {
                currentNoProductsContainer = document.createElement("div");
                currentNoProductsContainer.className =
                  "container container--no-products-in-collection text-align-center has-padding-bottom has-padding-top";

                const innerColumn = document.createElement("div");
                innerColumn.className = "one-whole column";

                const noProductsText = document.createElement("p");
                noProductsText.textContent =
                  "No products match the selected filters.";

                innerColumn.appendChild(noProductsText);
                currentNoProductsContainer.appendChild(innerColumn);

                if (productGrid && productGrid.parentNode) {
                  productGrid.parentNode.insertBefore(
                    currentNoProductsContainer,
                    productGrid
                  );
                  productGrid.style.display = "none";
                }
              } else {
                currentNoProductsContainer.style.display = "block";
                if (productGrid) {
                  productGrid.style.display = "none";
                }
              }

              // Hide pagination when no products
              const paginationContainer = document.querySelector(
                ".container--pagination"
              );
              if (paginationContainer) {
                paginationContainer.style.display = "none";
              }
            } else {
              // Hide any existing no-products message
              const currentNoProductsContainer = document.querySelector(
                ".container--no-products-in-collection"
              );
              if (currentNoProductsContainer) {
                currentNoProductsContainer.style.display = "none";
              }

              // Show the product grid
              if (productGrid) {
                productGrid.style.display = "grid";
              }

              // Extract the new product grid
              const newProductGrid = doc.querySelector(".collection-matrix");

              // Update product grid if found
              if (newProductGrid && productGrid) {
                productGrid.innerHTML = newProductGrid.innerHTML;
              }

              // Update pagination
              const pagination = document.querySelector(
                ".container--pagination"
              );
              const newPagination = doc.querySelector(".container--pagination");
              if (pagination && newPagination) {
                pagination.innerHTML = newPagination.innerHTML;
                pagination.style.display = "block";
              } else if (pagination && !newPagination) {
                pagination.style.display = "none";
              } else if (!pagination && newPagination) {
                const productGridWrapper = document.querySelector(
                  ".collection-matrix__wrapper"
                );
                if (productGridWrapper) {
                  const newPaginationClone = newPagination.cloneNode(true);
                  productGridWrapper.appendChild(newPaginationClone);
                }
              }
            }

            // Re-update the pagination links
            updatePaginationLinks();

            // Directly update filter counts
            document
              .querySelectorAll(".filter-count")
              .forEach((countElement) => {
                countElement.textContent = activeFilters.size || "0";
              });

            // Hide loading indicator
            if (loadingIcon) {
              loadingIcon.style.display = "none";
            }

            if (productGrid) {
              productGrid.classList.remove("loading");
              productGrid.style.opacity = "1";
            }

            // Re-initialize any product-specific JavaScript
            if (typeof window.reinitializeProductJS === "function") {
              window.reinitializeProductJS();
            }
          } catch (error) {
            console.error("Error processing popstate response:", error);
            // On error, reload the page
            window.location.reload();
          }
        })
        .catch((error) => {
          console.error("Error fetching during popstate:", error);
          // On fetch error, reload the page
          window.location.reload();
        });
    });

    // Initialize on page load
    updateFilterUI();
    updatePaginationLinks();

    // Add fallback reinitialize function if not defined
    if (typeof window.reinitializeProductJS !== "function") {
      window.reinitializeProductJS = function () {
        // Add any product-specific initialization needed
        console.log("Reinitializing product JS");
        // For example, reinitializing quick shop if it exists
        if (typeof initQuickShop === "function") {
          initQuickShop();
        }
      };
    }

    // Add CSS for loading states
    const styleElement = document.createElement("style");
    styleElement.type = "text/css";
    styleElement.innerHTML = `
        .collection-matrix.loading {
          opacity: 0.5 !important;
          position: relative;
          pointer-events: none;
          transition: opacity 0.3s ease;
        }
        
        .collection__loading-icon {
          display: none;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 100;
        }
        
        .filter-count {
          display: inline-block !important;
          visibility: visible !important;
          min-width: 8px !important;
        }
        
        /* Ensure filter count shows "0" when empty */
        .filter-count:empty::before {
          content: "0";
        }
      `;
    document.head.appendChild(styleElement);

    console.log("AJAX filtering initialized successfully");
  }
});
